<app-loader></app-loader>
<!-- <div class="main-container"> -->
   <router-outlet></router-outlet>
   <app-session-modal></app-session-modal>
<!-- </div> -->
<app-toast></app-toast> 

